module.exports = __webpack_public_path__ + "media/images/icons/align-left-c894103b77e8abaee019a0a98fe780da.svg";